/* CAFFREY Odo Fresh: page script (Claude Code, launch agent BUILDER, WORKFLOW-P, 2026-10-08).
   1. Releases Klaviyo's body scroll lock (its pop-up is hidden on this page, cf-of-page.css).
   2. <ofp-gallery>: two photos (the can, the can in a hand) in a snapping strip with arrows and dots. Photo 2 has no
      src until the page has loaded (or the shopper reaches for it), so it never competes with photo 1 (the LCP).
   3. Pictures just under the first screen wait in <noscript data-ofp-defer> until the hero photo has loaded (4 s at the
      latest; any scroll, tap or key releases them at once). Their boxes are reserved in CSS: nothing moves.
   4. The cutaway's two mist fans fade in once when the picture comes into view (static with reduced motion / no JS).
   5. Routine quick add: a sized product starts with no size; Add to cart asks for one (LAUNCH-BRIEF bulletin 6).
   Replaces assets/cf-of.js (left on the draft for rollback). */
(function () {
  if (window.CaffreyOdoFresh) return;
  window.CaffreyOdoFresh = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Klaviyo scroll lock */
  (function () {
    var b = document.body;
    if (!b) return;
    var free = function () { if (b.classList.contains('klaviyo-prevent-body-scrolling')) b.classList.remove('klaviyo-prevent-body-scrolling'); };
    free();
    if ('MutationObserver' in window) new MutationObserver(free).observe(b, { attributes: true, attributeFilter: ['class'] });
  })();

  /* 2. gallery */
  var loadLater = function (root) {
    root.querySelectorAll('[data-ofp-srcset]').forEach(function (el) {
      el.setAttribute('srcset', el.getAttribute('data-ofp-srcset'));
      el.removeAttribute('data-ofp-srcset');
    });
    root.querySelectorAll('img[data-ofp-src]').forEach(function (img) {
      img.setAttribute('src', img.getAttribute('data-ofp-src'));
      img.removeAttribute('data-ofp-src');
    });
  };

  class OfpGallery extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      this.track = this.querySelector('[data-ofp-track]');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-ofp-slide]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-ofp-dot]'));
      this.index = 0;
      if (!this.track || this.slides.length < 2) return;
      var later = function () { loadLater(self); };
      if (document.readyState === 'complete') setTimeout(later, 300);
      else window.addEventListener('load', function () { setTimeout(later, 300); }, { once: true });
      ['pointerdown', 'touchstart', 'focusin'].forEach(function (t) { self.addEventListener(t, later, { once: true, passive: true }); });
      this.track.addEventListener('scroll', function () { later(); }, { once: true, passive: true });
      this.dots.forEach(function (dot) {
        dot.addEventListener('click', function () { self.go(Number(dot.getAttribute('data-ofp-dot')) || 0); });
      });
      var prev = this.querySelector('[data-ofp-prev]');
      var next = this.querySelector('[data-ofp-next]');
      if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); });
      if (next) next.addEventListener('click', function () { self.go(self.index + 1); });
      this.track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); self.go(self.index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(self.index - 1); }
      });
      var sync = function () {
        var w = self.track.clientWidth || 1;
        var i = Math.round(self.track.scrollLeft / w);
        if (i !== self.index) self.mark(Math.max(0, Math.min(self.slides.length - 1, i)));
      };
      var t = null;
      this.track.addEventListener('scroll', function () { if (t) cancelAnimationFrame(t); t = requestAnimationFrame(sync); }, { passive: true });
      this.mark(0);
    }
    mark(i) {
      this.index = i;
      this.dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      this.slides.forEach(function (s, k) { s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
    }
    go(i) {
      var n = this.slides.length;
      i = ((i % n) + n) % n;
      loadLater(this);
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      this.mark(i);
    }
  }
  if (!customElements.get('ofp-gallery')) customElements.define('ofp-gallery', OfpGallery);

  /* 3. deferred pictures */
  var released = false;
  var release = function () {
    if (released) return;
    released = true;
    document.querySelectorAll('noscript[data-ofp-defer]').forEach(function (ns) {
      var html = ns.textContent || '';
      if (html.indexOf('<img') !== -1) ns.insertAdjacentHTML('beforebegin', html);
      ns.parentNode && ns.parentNode.removeChild(ns);
    });
    armMist();
  };
  var holdUntilHero = function () {
    if (!document.querySelector('noscript[data-ofp-defer]')) { armMist(); return; }
    var hero = document.querySelector('[data-ofp-hero]');
    if (!hero || (hero.complete && hero.naturalWidth > 0)) { release(); return; }
    hero.addEventListener('load', release, { once: true });
    hero.addEventListener('error', release, { once: true });
    ['scroll', 'touchstart', 'pointerdown', 'wheel', 'keydown'].forEach(function (type) {
      window.addEventListener(type, release, { once: true, passive: true, capture: true });
    });
    setTimeout(release, 4000);
  };

  /* 4. one-time mist fade */
  var mistArmed = false;
  function armMist() {
    if (mistArmed) return;
    mistArmed = true;
    if (reduce || !('IntersectionObserver' in window)) return;
    document.querySelectorAll('[data-ofp-mist]').forEach(function (fig) {
      var r = fig.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) return; /* already on screen: leave it as it is */
      fig.classList.add('is-armed');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { fig.classList.add('is-in'); io.disconnect(); }
        });
      }, { threshold: 0.45 });
      io.observe(fig);
    });
  }

  /* 5. routine size guard (capture phase: runs before Dawn's <product-form> submit handler) */
  var message = function (form, on) {
    var msg = form.querySelector('[data-ofp-size-msg]');
    if (msg) msg.hidden = !on;
    var select = form.querySelector('select[data-ofp-size]');
    if (select) select.setAttribute('aria-invalid', on ? 'true' : 'false');
  };
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('.ofp-routine')) return;
    var select = form.querySelector('select[data-ofp-size]');
    if (!select || select.value) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    message(form, true);
    select.focus();
  }, true);
  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.matches('select[data-ofp-size]')) return;
    if (select.value && select.form) message(select.form, false);
  });

  /* 6. Decorative hero motion: static without JS, pauses off-screen and respects live OS preference changes. */
  class OfpHeroMotion extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this._paused = Boolean(this._paused);
      this._inView = true;
      this._media = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._button = this.querySelector('[data-ofp-motion-toggle]');
      if (!this._button) return;
      this._sync = () => {
        var reduced = this._media.matches;
        this.dataset.animating = String(!reduced && !this._paused && this._inView && !document.hidden);
        this._button.hidden = reduced;
        this._button.setAttribute('aria-pressed', String(this._paused));
        this._button.setAttribute('aria-label', this._paused ? 'Resume background motion' : 'Pause background motion');
        var label = this._button.querySelector('[data-ofp-motion-label]');
        if (label) label.textContent = this._paused ? 'Resume motion' : 'Pause motion';
      };
      this._toggle = () => { this._paused = !this._paused; this._sync(); };
      this._button.addEventListener('click', this._toggle);
      this._media.addEventListener('change', this._sync);
      document.addEventListener('visibilitychange', this._sync);
      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver(entries => {
          this._inView = entries.some(entry => entry.isIntersecting);
          this._sync();
        }, { threshold: 0.1 });
        this._observer.observe(this.parentElement);
      }
      this._sync();
    }
    disconnectedCallback() {
      if (!this._connected) return;
      this._connected = false;
      if (this._observer) this._observer.disconnect();
      if (this._button) this._button.removeEventListener('click', this._toggle);
      if (this._media) this._media.removeEventListener('change', this._sync);
      document.removeEventListener('visibilitychange', this._sync);
    }
  }
  if (!customElements.get('ofp-hero-motion')) customElements.define('ofp-hero-motion', OfpHeroMotion);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', holdUntilHero, { once: true });
  else holdUntilHero();
})();
